// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"338f06d7","213":"cb48e05d","223":"024a722b","239":"23bc71c9","450":"17c2f491","732":"702f7752"}[chunkId] + ".chunk.js";
};